export const theme = {
  /// Base color themes
  brandPrimary: "var(--brand-primary)",
  brandSecondary: "var(--brand-secondary)",

  brandBorderSegment: "var(--brand-border-segment)",
  brandBorderColor: "var(--brand-border-color)",
  brandBorderRadius: "var(--brand-border-radius)",

  brandAiBackground: "var(--brand-ai-background)",
  brandAiTextBackground: "var(--brand-ai-text-background)",
  brandAiButtonColor: "var(--brand-ai-button-color)",

  brandTextPrimary: "var(--brand-text-primary)",
  brandTextSecondary: "var(--brand-text-secondary)",

  /// Colours
  brandFunctional: "var(--brand-functional)",

  brandPastelBlue: "var(--brand-pastel-blue)",
  brandPastelTeal: "var(--brand-pastel-teal)",
  brandPastelLightTeal: "var(--brand-pastel-light-teal)",
  brandPastelPearl: "var(--brand-pastel-pearl)",
  brandPastelRed: "var(--brand-pastel-red)",
  brandPastelPink: "var(--brand-pastel-pink)",
  brandPastelLightPink: "var(--brand-pastel-light-pink)",
  brandPastelPurple: "var(--brand-pastel-purple)",
  brandPastelPeach: "var(--brand-pastel-peach)",
  brandPastelYellow: "var(--brand-pastel-yellow)",
  brandPastelOlive: "var(--brand-pastel-olive)",
  brandPastelGrey: "var(--brand-pastel-grey)",

  brandNeutralBlack: "var(--brand-neutral-black)",
  brandNeutralSlate: "var(--brand-neutral-slate)",
  brandNeutralGreyDark: "var(--brand-neutral-grey-dark)",
  brandNeutralGrey: "var(--brand-neutral-grey)",
  brandNeutralGreyLight: "var(--brand-neutral-grey-light)",
  brandNeutralCoconut: "var(--brand-neutral-coconut)",
  brandNeutralWhite: "var(--brand-neutral-white)",

  brandAccentRed: "var(--brand-accent-red)",
  brandAccentYellow: "var(--brand-accent-yellow)",
  brandAccentGreen: "var(--brand-accent-green)",
  brandAccentBlue: "var(--brand-accent-blue)",
  brandAccentPurple: "var(--brand-accent-purple)",
  brandAccentPurpleAlt: "var(--brand-accent-purple-alt)",
  brandAccentPink: "var(--brand-accent-pink)",

  brandFeedbackRed: "var(--brand-feedback-red)",
  brandFeedbackYellow: "var(--brand-feedback-yellow)",
  brandFeedbackGreen: "var(--brand-feedback-green)",
  brandFeedbackBlue: "var(--brand-feedback-blue)",
  brandFeedbackPurple: "var(--brand-feedback-purple)",

  /// Font
  fontPrimary: "var(--font-primary)",
  fontSecondary: "var(--font-secondary)",

  /// Nav styling
  navButtonActive: "var(--nav-button-active)",
  navButtonBorderHeight: "var(--nav-button-border-height)",

  /// Chat
  chatPaddingSides: "var(--chat-padding-sides)",
  chatBoxColor: "var(--chat-box-color)",

  /// Switch
  switchOffColor: "var(--switch-off-color)",
  switchOnColor: "var(--switch-on-color)",

  /// Messages
  messageBackgroundLeft: "var(--message-background-left)",
  messageBackgroundRight: "var(--message-background-right)",
  messageTextColorLeft: "var(--message-text-color-left)",
  messageTextColorRight: "var(--message-text-color-right)",

  /// Buttons
  buttonBorderRadius: "var(--button-border-radius)",

  /// Footer
  chatFooterBackground: "var(--chat-footer-background)",
  chatFooterAiBackground: "var(--chat-footer-ai-background)",

  /// Login
  loginBackground: "var(--login-background)",
  loginButtonColor: "var(--login-button-color)",

  /// All Chats
  welcomeColor: "var(--welcome-color)",

  /// Slider
  sliderTrackedColor: "var(--slider-tracked-color)",

  /// Divider
  dividerColor: "var(--divider-color)",

  /// Transitions
  transition: "var(--transition)",
};

// Shorthand for theme
export const t = theme;
